(ns machtfit.stepchall.pagination
  (:require [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.search :as-alias search]
            [machtfit.translation :refer [tr]]
            [re-frame.core :as rf]))

(def ^:private items-per-page 10)

(defn paginate [items page]
  (-> (partition-all items-per-page items)
      (nth page [])))

(defn- page-of [items item]
  (or (some-> (keep-indexed (fn [idx indexed-item]
                              (when (= (:id indexed-item)
                                       (:id item))
                                idx))
                            items)
              first
              (quot items-per-page))
      0))

(defn- leaderboard-page [db scope]
  (let [{:keys [teams team
                participants participant]} (:stepchall db)
        scoped-page (get-in db [:ui :stepchall :leaderboard scope :page])
        my-page (case scope
                  :teams (page-of teams team)
                  :participants (page-of participants participant)
                  nil)]
    (or scoped-page my-page 0)))

(defn update-page
  ([{:keys [db] :as fx} update-fn]
   (update-page fx (-> db :ui :stepchall :leaderboard :scope) update-fn))
  ([{:keys [db] :as fx} scope update-fn]
   (assoc-in fx [:db :ui :stepchall :leaderboard scope :page]
             (-> db (leaderboard-page scope) update-fn))))

(defn init-db [fx]
  (-> fx
      (update-page :teams (constantly nil))
      (update-page :participants (constantly nil))))

(rf/reg-event-fx ::prev-clicked
  (fn [{:keys [db]} _]
    (update-page {:db db} dec)))

(rf/reg-event-fx ::next-clicked
  (fn [{:keys [db]} _]
    (update-page {:db db} inc)))

(rf/reg-event-fx ::to-first-page-clicked
  (fn [{:keys [db]} _]
    (update-page {:db db} (constantly 0))))

(rf/reg-sub ::leaderboard-page
  (fn [db _]
    (let [scope (-> db :ui :stepchall :leaderboard :scope)]
      (leaderboard-page db scope))))

(rf/reg-sub ::final-leaderboard-page
  :<- [:get [:ui :stepchall :leaderboard :scope]]
  :<- [::search/matching-teams :leaderboard]
  :<- [::search/matching-participants :leaderboard]

  (fn [[scope teams participants] _]
    (-> (case scope :teams teams :participants participants)
        count
        dec
        (quot items-per-page))))

(defn pagination []
  (let [page @(rf/subscribe [::leaderboard-page])
        final-page @(rf/subscribe [::final-leaderboard-page])]
    [:<>
     [:div.sc_pagination
      [:div (when (pos? page) [:button {:on-click #(rf/dispatch [::prev-clicked])} (icons/prev-page)])]
      [:div (str (inc page) " / " (inc final-page))]
      [:div (when-not (= page final-page) [:button {:on-click #(rf/dispatch [::next-clicked])} (icons/next-page)])]]
     (when (pos? page)
       [:div.sc_to-first-page
        [:button {:on-click #(rf/dispatch [::to-first-page-clicked])} (tr "Zu Top 10")]])]))
